var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBtnRetry = function SvgBtnRetry(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.03 8.74a6.843 6.843 0 1 0 5.96-4.028.6.6 0 0 1-.05-1.199 8.043 8.043 0 1 1-7.006 4.734.6.6 0 0 1 1.095.494Z",
    fill: "#7E8185"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.191 10.867 5.71 7.854 2.822 9.57M12 7v5h4",
    stroke: "#7E8185",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
};
export default SvgBtnRetry;